import { ClientDataService, IClientDataDoc } from '../../../../services/clientData.service'

export class LabsService extends ClientDataService {
  private LABS_DOC = 'tb_labs'
  private ABG_ACCESS_DOC = 'tb_labs_abg_access'

  async getLabsConfigDoc(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.LABS_DOC)
  }

  async getAbgAccessOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.ABG_ACCESS_DOC)
  }
}
